<template>
    <v-card :loading="loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-checkbox
                v-if="showTrashedCheckbox"
                class="pt-5 mr-5"
                v-model="showTrashed"
                label="Afisare informatiile sterse"
            />
            <search-field v-model="search"></search-field>
            <customer-selector button-class="mt-6" v-model="customerId"></customer-selector>
            <v-btn
                v-if="hasAddNewButton"
                color="primary"
                dark
                class="ml-2"
                @click="addNewItem"
            >
                Adaugare
            </v-btn>
            <v-dialog
                v-else
                v-model="dialog"
                max-width="500px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        Adaugare
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                    <v-text-field
                                        v-model="form.name"
                                        label="Dessert name"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                    <v-text-field
                                        v-model="form.calories"
                                        label="Calories"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                    <v-text-field
                                        v-model="form.fat"
                                        label="Fat (g)"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                    <v-text-field
                                        v-model="form.carbs"
                                        label="Carbs (g)"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                    <v-text-field
                                        v-model="form.protein"
                                        label="Protein (g)"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close"
                        >
                            Renuntare
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="save"
                        >
                            Salveaza
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            :footer-props="footerOptions"
            class="elevation-1"
        >
            <template v-slot:item.actions="{ item }">
                <v-icon
                    v-if="canUpdate(item)"
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="canDelete(item)"
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Utilaje / Echipamente',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Marca', value: 'brand' },
                { text: 'Model', value: 'model' },
                { text: 'Serie sasiu', value: 'chassis' },
                { text: 'Serie motor', value: 'engine' },
                { text: 'Numar inregistrare', value: 'vehicle_plate' },
                { text: 'Client', value: 'customer_name', sortable: false },
                { text: 'Data inregistrarii', value: 'created_at' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            meta: {
                pagination: {
                    count: 0,
                    current_page: 0,
                    per_page: 0,
                    total: 0,
                    total_pages: 0
                }
            },
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            editedIndex: -1,
            showTrashedCheckbox: true,
            showTrashed: false,
            customerId: undefined
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            showTrashed: {
                handler(val) {
                    this.initialize()
                }
            },
            customerId: {
                handler(val) {
                    this.initialize()
                }
            },
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.$db.Equipment
                    .append('customer_name')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                console.log(this.customerId);
                if(this.customerId instanceof Array && this.customerId.length) query = query.where('customerIds', this.customerId.join('|'))
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (item) {
                this.$router.push({ name: 'equipments-edit', params: { id: item.id } })
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Equipment) {
                    await item.delete().catch((err) => {
                        this.showError(err?.response?.data?.error)
                        throw err
                    })
                } else {
                    console.warn('Here comes the headache...')
                }
                this.dialogDelete = false
                await this.initialize()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function() {
                this.$router.push({ name: 'equipments-create' })
            }
        },
    };
</script>
